<template>
<div class="chapter">
<div class="inner_page">
<div id="Ded.html" xml:lang="en-US">
<div class="Basic-Text-Frame-6">
<p class="x1ded" id="toc_marker-5"><span class="char-style-override-1">T</span>his book is dedicated to my children: Kraig, Kyle, and Erin. I am so proud of each of you, not only for what you have accomplished with your lives but for the amazing adults you have become. Be sure to always follow your dreams and reach for the stars—and there’ll be no stopping you.</p>
<p class="txt-noi">Love you,</p>
<p class="txt-noi">Mom</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ded.vue?a0ac303e